const BASE = "/assets/icons";

export const icons = {
  // ── Networks ──────────────────────────────────────────────
  mtn:          `${BASE}/mtn.png`,
  airtel:       `${BASE}/airtel.png`,
  glo:          `${BASE}/glo.png`,

  // ── Cable TV ──────────────────────────────────────────────
  dstv:         `${BASE}/dstv-logo-vector.svg`,
  gotv:         `${BASE}/gotv-nigeria-logo-vector.svg`,

  // ── Electricity DISCOs ────────────────────────────────────
  aedc:         `${BASE}/abuja-electricity.jpg`,       // Abuja Electric
  bedc:         `${BASE}/benin-electricity.png`,       // Benin Electric
  ekedc:        `${BASE}/eko-electric.png`,            // Eko Electric
  ibedc:        `${BASE}/ibedc.png`,                   // Ibadan Electric
  ikedc:        `${BASE}/ikeja-electric.png`,          // Ikeja Electric
  jedc:         `${BASE}/jos-electirc.jpg`,            // Jos Electric
  kaedco:       `${BASE}/kaduna-elect.PNG`,            // Kaduna Electric (PNG version)
  kaedcoJpg:    `${BASE}/kaduna-electric.jpg`,         // Kaduna Electric (JPG version)
  phed:         `${BASE}/phed.gif`,                    // Port Harcourt Electric

  // ── Exams / Education ─────────────────────────────────────
  waec:         `${BASE}/waec.jpg`,
  neco:         `${BASE}/neco.jpg`,
  napteb:       `${BASE}/napteb.jpg`,
  nbais:        `${BASE}/nbais.jpg`,

  // ── Other ─────────────────────────────────────────────────
  jubyCapital:  `${BASE}/jubycapital.svg`,
  deposit:      `${BASE}/deposit.png`,
  clipart:      `${BASE}/clipart2570139.png`,
};

// ── Grouped exports for convenience ──────────────────────────

export const networkIcons = {
  MTN:     icons.mtn,
  AIRTEL:  icons.airtel,
  GLO:     icons.glo,
};

export const tvIcons = {
  DSTV:      icons.dstv,
  GOTV:      icons.gotv,
};

export const discoIcons = {
  AEDC:    icons.aedc,
  BEDC:    icons.bedc,
  EKEDC:   icons.ekedc,
  IBEDC:   icons.ibedc,
  IKEDC:   icons.ikedc,
  JEDC:    icons.jedc,
  KAEDCO:  icons.kaedco,
  PHEDC:   icons.phed,
};

export const examIcons = {
  WAEC:   icons.waec,
  NECO:   icons.neco,
  NAPTEB: icons.napteb,
  NBAIS:  icons.nbais,
};
